import { NumberField } from "@/components/admin/number-field";
import { RecordField } from "@/components/admin/record-field";
import { Show } from "@/components/admin/show";
import { useTranslate } from "ra-core";
import { Card, CardContent } from "@/components/ui/card";
import { AccountBalanceBadge } from "./AccountBalanceBadge";
import type { Account } from "../../types";

export const AccountShow = () => (
  <Show>
    <Card>
      <CardContent className="grid grid-cols-1 gap-4 md:grid-cols-2">
        <RecordField source="name" />
        <RecordField
          source="type"
          render={(r) => <AccountTypeText type={r.type} />}
        />
        <RecordField source="currency" />
        <RecordField source="initial_balance" field={NumberField} />
        <RecordField
          label="resources.accounts.fields.current_balance"
          source="id"
          render={(r) => <AccountBalanceBadge accountId={r.id} />}
        />
        <RecordField source="notes" className="md:col-span-2" />
      </CardContent>
    </Card>
  </Show>
);

const AccountTypeText = ({ type }: { type: Account["type"] }) => {
  const translate = useTranslate();
  return <>{translate(`resources.accounts.types.${type}`, { _: type })}</>;
};
